import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PredefinedPricingTier, PredefinedPricingTierValue } from '../models';

export const predefinedPricingTiersActions = createActionGroup({
    source: 'Predefined Pricing Tiers',
    events: {
        // Get list
        'Get Tiers': emptyProps(),
        'Get Tiers Success': props<{ payload: PredefinedPricingTier[] }>(),
        'Get Tiers Error': props<{ code: number }>(),
        // Save full list (replace)
        'Save Tiers': props<{ value: PredefinedPricingTierValue[] }>(),
        'Save Tiers Success': props<{ payload: PredefinedPricingTier[] }>(),
        'Save Tiers Error': props<{ code: number }>(),
        // Clear
        Clear: emptyProps(),
    },
});
